import { connect } from 'react-redux';
import React from 'react';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from "devextreme/data/array_store";
import { useTranslation } from 'react-i18next';

const getAgents = (data) =>
    new DataSource({
        store: new ArrayStore({
            data: data?.agents || [],
            key: 'userId',
        })
    });

const ActiveAgentsChats = (props) => {

    const dataSource = getAgents(props.data.data);
    const { t } = useTranslation();
    return (<DataGrid
        dataSource={dataSource}
        showBorders={false}
        columnAutoWidth={true}
        width={"100%"}
        height={"99%"}
        allowColumnResizing={true}
        repaintChangesOnly={true}
        loadPanel={{ enabled: false }}
        rtlEnabled={props.rtl}>

        <Column dataField="agentId" visible={false} />
        <Column dataField="username" caption={t("username")}/>
        <Column dataField="activeChats" width={170} caption={t("activechats")} />
        <Column dataField="postponedChats" width={170} caption={t("postponed")} />
        <Column dataField="total" width={170} caption={t("total")} />
    </DataGrid>);
};


const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        id: state.supervisor.id,
        rtl: state.parameters.rtl,
    };
};

export default connect(mapStateToProps, {})(ActiveAgentsChats);